import { IonGrid, IonRow, IonCol, IonButton, IonLabel, IonSlides, IonSlide, IonInput, IonModal, IonItem, IonContent} from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect, useRef} from 'react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { AddSupplierModal } from './Modal_AddSupplier';


import '../css/zInternal_css.css';


export function AddInvoiceModal_Projects (props) {


    let supplierNameRef = useRef('');
    let supplierPhoneRef = useRef('');
    let invoiceDescriptionRef = useRef('');

    let [quantity_state, setQuantity_state] = useState(1);
    let [paymentType_state, setPaymentType_state] = useState('mobile_money');

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [showPasswordModal, setShowPasswordModal] = useState(false); 
    let [showSupplierModal , setShowSupplierModal] = useState(false);
    //let [enteredPassword, setEnteredPassword] = useState('');
    let [searchResults, setSearchResults] = useState([]);

    let [takePhotoStatus, setTakePhotoStatus] = useState(false);
    let [selectedFile, setSelectedFile] = useState(null);
    let [invoiceAttachement, setInvoiceAttachment] = useState('/var/www/web/Public/fileServer/merchants/attachment-not-available.png');



    let [disableExpensePayButton, setDisableExpensePayButton] = useState(false);





    function handleEnterAttachement() {  

        fetch(baseURL+'fileServer/merchants/attachment-not-available.png')
        .then(res => res.blob())
        .then(data => {

            const blobUrl = URL.createObjectURL(data);

            let noImageFile = new File([data], blobUrl, {
                enctype: 'multipart/form-data',
                type: 'image/jpeg',
                name: 'xImageFile',
                accept: "image/*",
            });
            
            setInvoiceAttachment(noImageFile);

        })
    }

    function handleFileChange(event) {


        const file = event.target.files ? event.target.files[0] : null;
        setSelectedFile(file);
    }


    function searchSupplierList(event)
    {

        let searchCategory = event[0];
        let searchData = event[1];


        first_searchSuppliersInDB(searchCategory, searchData);

    }

    function first_searchSuppliersInDB(searchCategory, searchData, optionsData)
    { 

        let formData = new FormData();
        let Tracker = '';


        if(searchCategory === 'name')
        {
            /*
            formData.append('Tracker', '74002S_N');
            formData.append('user', acctID);
            formData.append('xSupplierSearchName', searchData);
            */

            Tracker = '74002S_N';
        }
        else if(searchCategory === 'phone')
        {
             /*
            formData.append('Tracker', '74002S_P');
            formData.append('user', acctID);
            formData.append('xSupplierSearchPhone', searchData);
            */

            Tracker = '74002S_P';

        }


        /*const requestOptions = {
            method: 'POST',
            credentials: 'include',
            body: formData
        }*/

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: Tracker,
                user: acctID,
                xSupplierSearchName: searchData,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

                        let rows = res.toString().split('~~~');

                        let rowLength = rows.length;

                            for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                            {
                                let cols = rows[rownum].split('|');

                                if(searchCategory === 'name')
                                {
                                    //setSearchResults(cols);

                                    setSearchResults((prevSearchResults) => {
                                        return prevSearchResults.concat({
                                            db_supplierId: cols[0],
                                            db_supplierName: cols[1],
                                            db_supplierPhoneNumber: cols[2],
                                            db_supplierAddressNumber: cols[3],
                                            db_supplierStreetName: cols[4],
                                            db_supplierCity: cols[5],
                                            db_supplierCountry: cols[6],
                                        })
                                    });
                                    //document.getElementById('searchSupplierNameList').insertAdjacentHTML('beforeend', '<option class=\'forRemoveProjectSearch\' data-id=\''+[cols[0], cols[1], searchCategory,]+'\'>'+cols[0]+'</option>'); // onclick=\'inventoryItemsSearchResults('+cols[0]+')\'
                                }
                                else if(searchCategory === 'phone')
                                {

                                    //setSearchResults(cols);

                                    setSearchResults((prevSearchResults) => {
                                        return prevSearchResults.concat({
                                            db_supplierId: cols[0],
                                            db_supplierName: cols[1],
                                            db_supplierPhoneNumber: cols[2],
                                            db_supplierAddressNumber: cols[3],
                                            db_supplierStreetName: cols[4],
                                            db_supplierCity: cols[5],
                                            db_supplierCountry: cols[6],
                                        })
                                    });
                                }
                            }
                    })
        }

    function addInvoice(event)
    {

        setDisableExpensePayButton(true);
 


                const date = new Date();
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
                const day = String(date.getDate()).padStart(2, '0');
                const year = date.getFullYear();

            const requestOptions0 = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74706_add_invoice_projects',
                    user: acctID,
                    xProjectID: props.data.projectID,
                    xSupplierName: event[1],
                    xInvoiceMobileNumber: event[0],
                    xInvoiceDescription: event[2],
                    xInvoiceImageAttachment: selectedFile,
                    //xPaymentType: "MTN-MOMO",
                    //xExpenseTotalAmount: parseFloat(event[0]).toFixed(2),
                    //xInvoiceDateCreated: `${month}/${day}/${year}`,
                    sessionID: sessionID,
                    
                }),
            }
    
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions0)
            .then(res => res.text())
            .then(data0 => {
    
                     alert(data0)

     
                })

    }



    function selectedFileHandler(event)
    {
        setSelectedFile(event);

    }

    function onSubmitPasswordHandler(enteredPassword)
    {
        addInvoice('reaper');
    }

    function closeModalHandler() {

        props.closeModal(false);
    }

    let timeout;

    function handleInput(event) {

        document.getElementById('searchSupplierNameList').innerHTML = '';
        document.getElementById('searchSupplierPhoneNumberList').innerHTML = '';

        clearTimeout(timeout); // Clear the previous timeout to reset the delay
        timeout = setTimeout(searchSupplierList(event), 2000); // Set a new timeout
    
    }

    return (

            <React.Fragment>
                {
                props.openModal == true ?
                (
                    <IonModal isOpen={ props.openModal }>
                    <IonContent className='bookedDetails_gridContent_multiple'>
                    <IonSlides pager='true' className='custom-pagination' options={{ speed: 100 }}>

                        <IonSlide>
                                <IonGrid className='gridText'>
                                    <IonRow>
                                        <IonCol>
                                            <label for='searchSupplierName'>Supplier Name:</label>
                                        </IonCol>
                                        <IonCol>
                                            <input type='text' id='searchSupplierName' ref={ supplierNameRef } placeholder='Search supplier name' onInput={() => handleInput(['name', supplierNameRef.current.value])} list='searchSupplierNameList' autocomplete='off' required></input>
                                            <datalist id='searchSupplierNameList'>
                                                {searchResults.map((result) => (
                                                    <option key={result.db_supplierId} value={result.db_supplierName}></option>
                                                ))}
                                            </datalist>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <label for='searchSupplierPhoneNumber'>Supplier Phone Number:</label>
                                        </IonCol>
                                        <IonCol>
                                            <input type='text' id='searchSupplierPhoneNumber' ref={ supplierPhoneRef }  placeholder='Search supplier phone number' onInput={() => handleInput(['phone', supplierPhoneRef.current.value])} list='searchSupplierPhoneNumberList' autocomplete='off' required></input>
                                            <datalist id='searchSupplierPhoneNumberList'>
                                                {searchResults.map((result) => (
                                                    <option key={result.db_supplierId} value={result.db_supplierPhoneNumber}></option>
                                                ))}
                                            </datalist>
                                        </IonCol>
                                    </IonRow>
                                    {/*<IonRow>
                                        <IonCol>
                                            <IonButton  onClick={() => setShowSupplierModal(true)}> Add Supplier</IonButton>
                                        </IonCol>
                                    </IonRow>*/}
                                </IonGrid>

                            <AddSupplierModal  openModal={ showSupplierModal } closeModal={() => setShowSupplierModal(false)}></AddSupplierModal>
                        </IonSlide>
                        <IonSlide>
                                <IonGrid  className='gridText'>
                                    <IonRow>
                                        <IonCol>
                                            <IonLabel>Invoice Description: </IonLabel>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <IonInput type='text' placeholder='Enter Description' ref={ invoiceDescriptionRef }></IonInput>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            {(authenticatedMerchent_context.accessRights[0] == 'admin'  || authenticatedMerchent_context.accessRights[0] == 'manager') && <IonButton id='gridResultColumnButton' disabled={disableExpensePayButton} onClick={() => addInvoice([supplierPhoneRef.current.value, supplierNameRef.current.value, invoiceDescriptionRef.current.value])}> Add </IonButton>}
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                        </IonSlide>
                        {/* <IonSlide>
                                <IonGrid className='gridText'>
                                   <IonRow>
                                        <IonCol>                            
                                            <IonButton  onClick={() => setTakePhotoStatus(true)}> Take Photo</IonButton>
                                            {takePhotoStatus == true && <TakePhoto onSelectedFile={selectedFileHandler}></TakePhoto>}
                                        </IonCol>
                                        <IonCol>
                                            <input
                                                type="file"
                                                accept="image/jpeg"
                                                onChange={handleFileChange}
                                            />
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <label for='noAttachment'>No Attachment</label>
                                        </IonCol>
                                        <IonCol>
                                            <input type='checkbox' id='noAttachment' onClick={() => handleEnterAttachement()}></input>
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                            </IonSlide>*/}
                    </IonSlides>
                    
                    <IonButton className='button_closeModal_center' onClick={() => closeModalHandler(false)}>Cancel </IonButton>

                        {/*<EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>*/}                        
                        {/*<IonButton onClick={() => setShowPasswordModal(true)}> Add Expense </IonButton>*/}
                        </IonContent>
                    </IonModal>) : null
                }
            </React.Fragment>

    )
}